/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Condensed from './Condensed/index'
import Expanded from './Expanded/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCount({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/AppointmentCount"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabIsFullWidthValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'is_full_width',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabIsFullWidthValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Expanded'}>
<Expanded
  viewPath={`${viewPath}/Expanded`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Condensed'}>
<Condensed
  viewPath={`${viewPath}/Condensed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}